import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseInstallmentTerminals() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getInstallmentTerminals = (callback, bool) => {
    MyAxios.get(`Admin_InstallmentTerminals`, {
      headers: {
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateInstallmentTerminals = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_InstallmentTerminals`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  return {
    getInstallmentTerminals,
    UpdateInstallmentTerminals,
  };
}
